<template>
  <div class=""></div>
</template>

<script>
import mixin from '@/mixin'
export default {
  mixins: [mixin],
  components: {},
  props: {
    showAddressBook: {
      type: Boolean,
      default: false
    },
    studentGroupId: {
      type: String,
      default: ''
    },
    checkMemberConflict: {
      type: Boolean,
      default: true
    },
    addressType: {
      type: Number,
      default: 1 // 通讯录业务类型： 默认1 宿管通讯录2
    }
  },
  data() {
    return {
      type: +(this.$route.query || {}).type || 0
    }
  },
  computed: {},
  watch: {
    showAddressBook: {
      handler(show) {
        show && this.init()
      },
      immediate: true
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    init() {
      this.handlerToSelectDeptsOrMembers()
    },
    /**
     * 通讯录选择范围
     */
    handlerToSelectDeptsOrMembers(selectType) {
      let _addressBook = {
        tagId: this.$store.getters.currentTagId || 0,
        needReturn: true,
        removeDelay: 100,
        sandboxId: this.$store.getters.sandboxId || '',
        campusId: this.campusId,
        studentGroupId: this.studentGroupId,
        isSandboxComplete: this.$store.getters.isSandboxComplete || false,
        memberCount: this.$store.getters.memberCount || 0,
        checkMemberConflict: this.checkMemberConflict,
        addressType: this.addressType
      }
      this.$addressBook(_addressBook)
        .then(res => {
          if (res.$type !== 'onlyReturn') {
            this.$store.commit('memberCount', res.memberCount || 0)
            this.$store.commit('addressModifyMember', true)
          }
          this.$emit('close')
        })
        .catch(err => {
          this.$emit('close')
          console.log(err)
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>
